<script>
import Vue from 'vue'
import { DEFAULT_DATE, FORMAT_DATE } from '@/utils/config'

export const getDate = (amount = 0) => {
  const d = new Date()
  d.setDate(d.getDate() + amount)
  return d.toISOString().slice(0, 10)
}

export default {
  name: 'Date',
  methods: {
    toDefaultDate (date) {
      if (Vue.moment(date, DEFAULT_DATE, true).isValid()) {
        return Vue.moment(date, DEFAULT_DATE).format(DEFAULT_DATE)
      }
      if (Vue.moment(date, FORMAT_DATE, true).isValid()) {
        return Vue.moment(date, FORMAT_DATE).format(DEFAULT_DATE)
      }
      return date
    },
    toUiDate (date) {
      if (Vue.moment(date, FORMAT_DATE, true).isValid()) {
        return Vue.moment(date, FORMAT_DATE).format(FORMAT_DATE)
      }
      if (Vue.moment(date, DEFAULT_DATE, true).isValid()) {
        return Vue.moment(date, DEFAULT_DATE).format(FORMAT_DATE)
      }
      return date
    },

    getDate
  }
}

</script>
